/* Kraft & Ink — shop behaviour (2026-10-03).
   Loaded (defer) by sections/lineup-grid.liquid, sections/main-collection
   and snippets/quick-add.liquid. May be included more than once on a page:
   everything below is idempotent.

   1. Pack ladder (snippets/ki-pack-ladder.liquid): keeps the ADD label's
      pack name honest when a row is tapped. theme.js already owns the
      variant id, aria-pressed and the [data-price] sync — nothing here adds
      to the cart.
   2. Lineup (sections/lineup-grid.liquid, tab mode):
      - tabs (role=tablist, arrow keys); the opening tab follows ?ritual=,
        then html[data-world] (set by the hero's head script); later
        `cc:world` events move the tab until the shopper touches the tabs.
      - formula: NO default. ?formula=, sessionStorage.cc_formula or a
        `cc:formula` event may pre-set it (that is the shopper's own tap on
        a hero formula button). Otherwise the panel is .is-unchosen: block
        0's ladder shows, its submit hides, and the prompt button
        (aria-disabled, focusable, never dimmed) highlights both cards.
      - the chosen formula's pack carries over when the formula changes.
   Listens: cc:world {detail.world: day|night|joe|tini},
            cc:formula {detail.formula: infused|cbd-forward, detail.ritual?},
            shopify:section:load, shopify:block:select.
   Emits: nothing of its own (analytics ride on data-cc-event clicks,
   which theme.js forwards as cc:analytics). */
(function () {
  'use strict';
  var W = window;
  var live = function (msg) {
    var el = document.querySelector('[data-cc-live]');
    if (!el || !msg) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  };
  var arr = function (list) { return Array.prototype.slice.call(list || []); };
  var normFormula = function (f) {
    f = String(f || '').toLowerCase();
    if (!f) return '';
    if (f.indexOf('cbd') > -1 || f.indexOf('micro') > -1) return 'cbd';
    if (f === 'infused') return 'infused';
    return '';
  };
  var normWorld = function (w) {
    w = String(w || '').toLowerCase();
    if (w === 'night' || w === 'tini' || w === 'evening') return 'tini';
    if (w === 'day' || w === 'joe' || w === 'morning') return 'joe';
    if (w === 'mixed' || w === 'both') return 'mixed';
    return '';
  };
  var params = (function () {
    try { return new URLSearchParams(W.location.search); } catch (e) { return { get: function () { return null; } }; }
  })();
  var storedFormula = function () {
    try { return W.sessionStorage.getItem('cc_formula') || ''; } catch (e) { return ''; }
  };
  var reduced = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Pack label sync (delegated once) ─────────────────────────────── */
  if (!W.__kiShopPack) {
    W.__kiShopPack = 1;
    document.addEventListener('click', function (e) {
      var chip = e.target && e.target.closest ? e.target.closest('[data-kp-chip]') : null;
      if (!chip || chip.disabled) return;
      var form = chip.closest('form');
      var label = form && form.querySelector('[data-kp-pack]');
      if (label) label.textContent = chip.getAttribute('data-kp-title') || label.textContent;
    });
  }

  /* ── 2. Lineup ───────────────────────────────────────────────────────── */
  function setupPanel(panel) {
    var choices = arr(panel.querySelectorAll('[data-lnx-choice]'));
    var wrap = panel.querySelector('[data-lnx-choices]');
    var products = arr(panel.querySelectorAll('[data-lnx-product]'));
    var figs = arr(panel.querySelectorAll('[data-lnx-fig]'));
    var prompt = panel.querySelector('[data-lnx-prompt]');
    var hint = panel.querySelector('[data-lnx-hint]');
    panel.__userFormula = false;

    function visibleProduct() {
      for (var i = 0; i < products.length; i++) if (!products[i].hidden) return products[i];
      return null;
    }

    function unchosen() {
      panel.setAttribute('data-formula', '');
      panel.classList.add('is-unchosen');
      products.forEach(function (p, i) { p.hidden = i !== 0; });
      figs.forEach(function (f) { f.hidden = false; });
      choices.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      if (prompt) prompt.hidden = false;
    }

    function choose(f, opts) {
      opts = opts || {};
      var target = null;
      products.forEach(function (p) { if (p.getAttribute('data-formula') === f) target = p; });
      if (!target) return false;
      var prev = visibleProduct();
      var prevChip = prev && prev !== target ? prev.querySelector('[data-kp-chip][aria-pressed="true"]') : null;
      var prevNum = prevChip ? prevChip.getAttribute('data-kp-num') : null;

      panel.setAttribute('data-formula', f);
      panel.classList.remove('is-unchosen');
      if (wrap) wrap.classList.remove('is-prompting');
      if (hint) hint.hidden = true;
      if (prompt) prompt.hidden = true;
      choices.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-formula') === f)); });
      products.forEach(function (p) { p.hidden = p !== target; });
      figs.forEach(function (fg) { fg.hidden = fg.getAttribute('data-formula') !== f; });

      /* carry the pack the shopper already picked (same pack, other formula) */
      if (opts.user && prevNum && prevNum !== '0') {
        var match = target.querySelector('[data-kp-chip][data-kp-num="' + prevNum + '"]');
        if (match && !match.disabled && match.getAttribute('aria-pressed') !== 'true') match.click();
      }
      if (opts.user) {
        panel.__userFormula = true;
        live(target.getAttribute('data-lnx-title') || '');
      }
      return true;
    }

    panel.__lnxChoose = choose;

    if (choices.length < 2) return; /* one product (e.g. Day & Night): nothing to choose */

    choices.forEach(function (c) {
      c.addEventListener('click', function () { choose(c.getAttribute('data-formula'), { user: true }); });
    });
    if (prompt) {
      prompt.addEventListener('click', function () {
        if (wrap) wrap.classList.add('is-prompting');
        if (hint) hint.hidden = false;
        live(prompt.getAttribute('data-hint') || '');
        if (wrap && wrap.scrollIntoView) {
          try { wrap.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); } catch (e) { wrap.scrollIntoView(); }
        }
        if (choices[0]) {
          try { choices[0].focus({ preventScroll: true }); } catch (e) { choices[0].focus(); }
        }
      });
    }

    var pre = normFormula(params.get('formula')) || normFormula(storedFormula());
    if (!(pre && choose(pre))) unchosen();
  }

  function initLineup(shell) {
    if (!shell || shell.getAttribute('data-lnx-bound')) return;
    shell.setAttribute('data-lnx-bound', '1');
    shell.classList.remove('lnx--nojs'); /* editor reloads may skip the inline remover */
    shell.classList.add('lnx--js');

    var panels = arr(shell.querySelectorAll('[data-lnx-panel]'));
    panels.forEach(setupPanel);

    var tablist = shell.querySelector('[data-lnx-tablist]');
    var tabs = tablist ? arr(tablist.querySelectorAll('[data-lnx-tab]')) : [];
    var touched = false;

    shell.__lnxFormula = function (f, ritual) {
      f = normFormula(f);
      if (ritual) shell.__lnxWorld(ritual, true);
      if (!f) return;
      panels.forEach(function (p) { if (!p.__userFormula && p.__lnxChoose) p.__lnxChoose(f); });
    };

    if (tabs.length < 2 || tabs.length !== panels.length) {
      shell.__lnxWorld = function () {};
      return;
    }

    tablist.hidden = false;
    panels.forEach(function (p, i) {
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('tabindex', '0');
      p.setAttribute('aria-labelledby', tabs[i].id);
    });

    function activate(idx, focus) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) { p.hidden = i !== idx; });
      if (focus) tabs[idx].focus();
    }
    function indexFor(world) {
      for (var i = 0; i < panels.length; i++) if (panels[i].getAttribute('data-world') === world) return i;
      return -1;
    }

    shell.__lnxShow = function (panel) {
      var i = panels.indexOf(panel);
      if (i > -1) activate(i);
    };
    shell.__lnxWorld = function (w, force) {
      if (touched && !force) return;
      var i = indexFor(normWorld(w));
      if (i > -1) activate(i);
    };

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { touched = true; activate(i); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); touched = true; activate(next, true); }
      });
    });

    var start = indexFor(normWorld(params.get('ritual')));
    if (start < 0) start = indexFor(normWorld(document.documentElement.getAttribute('data-world')));
    activate(start < 0 ? 0 : start);
  }

  function scan(root) {
    arr((root || document).querySelectorAll('[data-lnx-shell]')).forEach(initLineup);
  }

  scan(document);

  if (!W.__kiShopWired) {
    W.__kiShopWired = 1;
    document.addEventListener('cc:world', function (e) {
      var w = e && e.detail ? (e.detail.world || e.detail.ritual) : '';
      arr(document.querySelectorAll('[data-lnx-shell]')).forEach(function (s) { if (s.__lnxWorld) s.__lnxWorld(w); });
    });
    document.addEventListener('cc:formula', function (e) {
      var d = (e && e.detail) || {};
      arr(document.querySelectorAll('[data-lnx-shell]')).forEach(function (s) { if (s.__lnxFormula) s.__lnxFormula(d.formula, d.ritual || d.world); });
    });
    document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target && e.target.closest ? e.target.closest('[data-lnx-panel]') : null;
      var shell = panel && panel.closest('[data-lnx-shell]');
      if (shell && shell.__lnxShow) shell.__lnxShow(panel);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  }
})();
